<template>
  <main class="p-3">
    <router-view />
  </main>
</template>

<script setup>
</script>
